import { render, staticRenderFns } from "./DeminimisThreshold.vue?vue&type=template&id=95fa9aa4"
import script from "./DeminimisThreshold.vue?vue&type=script&lang=js"
export * from "./DeminimisThreshold.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports